import { DataSource } from "@angular/cdk/collections";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { B2BShipment } from "../components/b2b/b2b-shipments-list/shipment.interface";
import { SignupService } from "./signup.service";

@Injectable()

export class B2BShipmentsDataSource extends DataSource<any> {

    constructor(private signupService: SignupService) {
        super()
    }

    shipments$ = new BehaviorSubject<B2BShipment[]>([]);
    isShipmentsLoading$ = new BehaviorSubject<boolean>(false);

    serviceTypeList = [
        { name: 'Express', id: 1 },
        { name: 'Economy', id: 2 },
        { name: 'Connect Plus', id: 3 },
        { name: 'Standard', id: 4 },
        { name: 'Regional Economy', id: 5 },
    ]
    courierList = [
        { name: 'TNT', id: 1 },
        { name: 'UPS', id: 2 },
        { name: 'DHL', id: 3 },
        { name: 'FedEx', id: 4 },
        { name: 'AusPost', id: 5 },
        { name: 'USPS', id: 6 },
        { name: 'Aramex', id: 7 },
        { name: 'LaPoste', id: 8 },
        { name: 'TNT', id: 9 },
        { name: 'TNT', id: 10 },
        { name: 'MNG', id: 11 },
        { name: 'EMS', id: 12 },
        { name: 'DPD', id: 13 },
        { name: 'Evri', id: 14 },

    ]
    b2bShipmentStatusList = [
        { name: 'Waiting Payment', id: 6 },
        { name: 'Ready To Shipment', id: 7 },
        { name: 'In Transit', id: 8 },
        { name: 'Shipped', id: 8 },
        { name: 'Delivered', id: 9 },
    ]

    getCourierName(company_id) {
        let companyName;
        this.courierList.find(element => {
            if (element.id == company_id) {
                companyName = element.name;
                return companyName;

            }
        });
        return companyName;

    }
    getServiceTypeName(serviceType) {
        let serviceTypeName;
        this.serviceTypeList.find(element => {
            if (element.id == serviceType) {
                serviceTypeName = element.name;
                return serviceTypeName;

            }
        });
        return serviceTypeName;

    }

    getShipmentStatusName(status) {
        let statusName;
        this.b2bShipmentStatusList.find(element => {
            if (element.id == status) {
                statusName = element.name;
                return statusName;

            }
        });
        return statusName;

    }

    connect(): Observable<B2BShipment[]> {
        return this.shipments$.asObservable();
    }
    disconnect(): void {
        this.shipments$.complete();
    }

    loadShipmnetsByUserID(userID, token) {
        this.isShipmentsLoading$.next(true)
        this.signupService.listB2BShipmentsViaUserID(token, userID).subscribe({
            next: data => {


                let tempData = data["data"].filter(element => element.status >= 7);

                tempData.forEach(element => {
                    element.shipment.company_name = this.getCourierName(element.shipment.company_id);
                    element.shipment.service_type_name = this.getServiceTypeName(element.shipment.service_type);
                    element.status_name = this.getShipmentStatusName(element.status);
                });
                this.shipments$.next(tempData);
                this.isShipmentsLoading$.next(false);
            }
        })

    }

    


}